import * as React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { Box } from "@mui/material";
import SidebarMenu from "./configuration/sidebarMenus";
import styles from "./setting.module.css";
import { MainContainer } from "../../../components/ContentWrapper";

export default function SettingsPage() {
    // const matchRoute = useMatch()
    // console.log({ matchRoute })
    // const { socket } = useSocket()
    // if (socket && socket.connected) {
    //     socket.on('connect', () => {
    //         console.log('Connected to server socket')
    //     })
    // }

    return (
        <MainContainer title="settings">
            <Box className="flex flex-col justify-between items-start items-center sm:flex-row sm:items-start bg-surface">
                <Box
                    className="min-w-[200px] rounded-xl flex px-4 mb-3 flex-row sm:block sm:px-0 sm:py-4 sm:mb-0 sm:flex-col"
                    sx={{
                        gap: "32px"
                    }}
                >
                    {SidebarMenu.map((sidebarItem, index) => (
                        <NavLink
                            key={`nav-${index}`}
                            to={sidebarItem.link}
                            className={({ isActive }) => `${styles.navlink} ${isActive && styles.active}`}
                        >
                            {sidebarItem.label}
                        </NavLink>
                    ))}
                </Box>
                <div className="w-full rounded-xl p-5" style={{ width: "100%" }}>
                    <Outlet />
                </div>
            </Box>
        </MainContainer>
    );
}
